import React from "react";
import PropTypes from "prop-types";

const voiceModeMicIcon = ({ color = "#ffffff" }) => {
  return (
    <svg width="52" height="52" viewBox="0 0 24 24" fill={color}>
      <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.53-1.82 4.43-4.25 4.9V21h-1.5v-1.1C7.82 16.43 6 14.53 6 12h1.5c0 1.91 1.56 3.47 3.5 3.47s3.5-1.56 3.5-3.47H17z" />
    </svg>
  );
};

voiceModeMicIcon.propTypes = {
  color: PropTypes.string,
};
export default voiceModeMicIcon;
